export const PERMISSION_DASHBOARD = 'PERMISSION_DASHBOARD'
export const PERMISSION_DASHBOARD_PRODUCT_SEARCH = 'PERMISSION_DASHBOARD_PRODUCT_SEARCH'

// Yes.. it's like a typescript any, but better
export const PERMISSION_ANY = 'PERMISSION_ANY'

export const PERMISSION_MEDIA = 'PERMISSION_MEDIA'

export const PERMISSION_ABSENCESCHEDULE_CREATE = 'PERMISSION_ABSENCESCHEDULE_CREATE'
export const PERMISSION_ABSENCESCHEDULE_READ = 'PERMISSION_ABSENCESCHEDULE_READ'
export const PERMISSION_ABSENCESCHEDULE_UPDATE = 'PERMISSION_ABSENCESCHEDULE_UPDATE'
export const PERMISSION_ABSENCESCHEDULE_DELETE = 'PERMISSION_ABSENCESCHEDULE_DELETE'

export const PERMISSION_ACCOUNT_CREATE = 'PERMISSION_ACCOUNT_CREATE'
export const PERMISSION_ACCOUNT_CREATE_PRIVATE = 'PERMISSION_ACCOUNT_CREATE_PRIVATE'
export const PERMISSION_ACCOUNT_CREATE_PRIVATE_SIMPLE = 'PERMISSION_ACCOUNT_CREATE_PRIVATE_SIMPLE'
export const PERMISSION_ACCOUNT_READ = 'PERMISSION_ACCOUNT_READ'
export const PERMISSION_ACCOUNT_READ_PRIVATE = 'PERMISSION_ACCOUNT_READ_PRIVATE'
export const PERMISSION_ACCOUNT_UPDATE = 'PERMISSION_ACCOUNT_UPDATE'
export const PERMISSION_ACCOUNT_DELETE = 'PERMISSION_ACCOUNT_DELETE'

export const PERMISSION_ACTIVITY_CREATE = 'PERMISSION_ACTIVITY_CREATE'
export const PERMISSION_ACTIVITY_READ = 'PERMISSION_ACTIVITY_READ'
export const PERMISSION_ACTIVITY_UPDATE = 'PERMISSION_ACTIVITY_UPDATE'
export const PERMISSION_ACTIVITY_DELETE = 'PERMISSION_ACTIVITY_DELETE'

export const PERMISSION_WO_PACKAGES_READ = 'PERMISSION_WO_PACKAGES_READ'

export const PERMISSION_WO_DEFAULT_TEXT_LINES = 'PERMISSION_WO_DEFAULT_TEXT_LINES'
export const PERMISSION_WO_DEFAULT_CUSTOM_LINES = 'PERMISSION_WO_DEFAULT_CUSTOM_LINES'

export const PERMISSION_ADMINISTRATION_CREATE = 'PERMISSION_ADMINISTRATION_CREATE'
export const PERMISSION_ADMINISTRATION_READ = 'PERMISSION_ADMINISTRATION_READ'
export const PERMISSION_ADMINISTRATION_UPDATE = 'PERMISSION_ADMINISTRATION_UPDATE'
export const PERMISSION_ADMINISTRATION_DELETE = 'PERMISSION_ADMINISTRATION_DELETE'

export const PERMISSION_APPOINTMENT_CREATE = 'PERMISSION_APPOINTMENT_CREATE'
export const PERMISSION_APPOINTMENT_READ = 'PERMISSION_APPOINTMENT_READ'
export const PERMISSION_APPOINTMENT_UPDATE = 'PERMISSION_APPOINTMENT_UPDATE'
export const PERMISSION_APPOINTMENT_DELETE = 'PERMISSION_APPOINTMENT_DELETE'

export const PERMISSION_ARCHIVEORDER_CREATE = 'PERMISSION_ARCHIVEORDER_CREATE'
export const PERMISSION_ARCHIVEORDER_READ = 'PERMISSION_ARCHIVEORDER_READ'
export const PERMISSION_ARCHIVEORDER_UPDATE = 'PERMISSION_ARCHIVEORDER_UPDATE'
export const PERMISSION_ARCHIVEORDER_DELETE = 'PERMISSION_ARCHIVEORDER_DELETE'

export const PERMISSION_CLOSINGSTATEMENT_READ = 'PERMISSION_CLOSINGSTATEMENT_READ'

export const PERMISSION_COMPANY_CREATE = 'PERMISSION_COMPANY_CREATE'
export const PERMISSION_COMPANY_READ = 'PERMISSION_COMPANY_READ'
export const PERMISSION_COMPANY_UPDATE = 'PERMISSION_COMPANY_UPDATE'
export const PERMISSION_COMPANY_DELETE = 'PERMISSION_COMPANY_DELETE'

export const PERMISSION_COMPANYACCOUNT_CREATE = 'PERMISSION_COMPANYACCOUNT_CREATE'
export const PERMISSION_COMPANYACCOUNT_READ = 'PERMISSION_COMPANYACCOUNT_READ'
export const PERMISSION_COMPANYACCOUNT_UPDATE = 'PERMISSION_COMPANYACCOUNT_UPDATE'
export const PERMISSION_COMPANYACCOUNT_DELETE = 'PERMISSION_COMPANYACCOUNT_DELETE'

export const PERMISSION_COURTESYVEHICLES_READ = 'PERMISSION_COURTESYVEHICLES_READ'
export const PERMISSION_COURTESYVEHICLES_UPDATE = 'PERMISSION_COURTESYVEHICLES_UPDATE'

export const PERMISSION_CLOCKITEMS_CREATE = 'PERMISSION_CLOCKITEMS_CREATE'
export const PERMISSION_CLOCKITEMS_READ = 'PERMISSION_CLOCKITEMS_READ'
export const PERMISSION_CLOCKITEMS_UPDATE = 'PERMISSION_CLOCKITEMS_UPDATE'
export const PERMISSION_CLOCKITEMS_DELETE = 'PERMISSION_CLOCKITEMS_DELETE'

export const PERMISSION_CLOCKINGACTIONS_READ = 'PERMISSION_CLOCKINGACTIONS_READ'
export const PERMISSION_CLOCKINGACTIONS_DAY = 'PERMISSION_CLOCKINGACTIONS_DAY'
export const PERMISSION_CLOCKINGACTIONS_ITEMS = 'PERMISSION_CLOCKINGACTIONS_ITEMS'
export const PERMISSION_CLOCKINGACTIONS_WORKORDER = 'PERMISSION_CLOCKINGACTIONS_WORKORDER'

export const PERMISSION_CONCEPT_CREATE = 'PERMISSION_CONCEPT_CREATE'
export const PERMISSION_CONCEPT_READ = 'PERMISSION_CONCEPT_READ'
export const PERMISSION_CONCEPT_UPDATE = 'PERMISSION_CONCEPT_UPDATE'
export const PERMISSION_CONCEPT_DELETE = 'PERMISSION_CONCEPT_DELETE'

export const PERMISSION_CONCEPT_UPDATE_BRANDS = 'PERMISSION_CONCEPT_UPDATE_BRANDS'
export const PERMISSION_CONCEPT_UPDATE_IMAGES = 'PERMISSION_CONCEPT_UPDATE_IMAGES'

export const PERMISSION_CONCEPT_READ_TENDERS = 'PERMISSION_CONCEPT_READ_TENDERS'

export const PERMISSION_DEBITCREDIT_READ = 'PERMISSION_DEBITCREDIT_READ'
export const PERMISSION_DEBITCREDIT_UPDATE = 'PERMISSION_DEBITCREDIT_UPDATE'

export const PERMISSION_DEFAULTSTOCK_READ = 'PERMISSION_DEFAULTSTOCK_READ'
export const PERMISSION_DEFAULTSTOCK_UPDATE = 'PERMISSION_DEFAULTSTOCK_UPDATE'

export const PERMISSION_EMAILSETTINGS_CREATE = 'PERMISSION_EMAIL_CREATE'
export const PERMISSION_EMAILSETTINGS_READ = 'PERMISSION_EMAIL_READ'
export const PERMISSION_EMAILSETTINGS_UPDATE = 'PERMISSION_EMAIL_UPDATE'
export const PERMISSION_EMAILSETTINGS_DELETE = 'PERMISSION_EMAIL_DELETE'

export const PERMISSION_EMAILHISTORY_CREATE = 'PERMISSION_EMAILHISTORY_CREATE'
export const PERMISSION_EMAILHISTORY_READ = 'PERMISSION_EMAILHISTORY_READ'
export const PERMISSION_EMAILHISTORY_UPDATE = 'PERMISSION_EMAILHISTORY_UPDATE'
export const PERMISSION_EMAILHISTORY_DELETE = 'PERMISSION_EMAILHISTORY_DELETE'

export const PERMISSION_EMPLOYEE_CREATE = 'PERMISSION_EMPLOYEE_CREATE'
export const PERMISSION_EMPLOYEE_READ = 'PERMISSION_EMPLOYEE_READ'
export const PERMISSION_EMPLOYEE_UPDATE = 'PERMISSION_EMPLOYEE_UPDATE'
export const PERMISSION_EMPLOYEE_DELETE = 'PERMISSION_EMPLOYEE_DELETE'

export const PERMISSION_EMPLOYEESKILL_CREATE = 'PERMISSION_EMPLOYEESKILL_CREATE'
export const PERMISSION_EMPLOYEESKILL_READ = 'PERMISSION_EMPLOYEESKILL_READ'
export const PERMISSION_EMPLOYEESKILL_UPDATE = 'PERMISSION_EMPLOYEESKILL_UPDATE'
export const PERMISSION_EMPLOYEESKILL_DELETE = 'PERMISSION_EMPLOYEESKILL_DELETE'

export const PERMISSION_HAYNES_CREATE = 'PERMISSION_HAYNES_CREATE'
export const PERMISSION_HAYNES_READ = 'PERMISSION_HAYNES_READ'
export const PERMISSION_HAYNES_UPDATE = 'PERMISSION_HAYNES_UPDATE'
export const PERMISSION_HAYNESCHECKLIST_UPDATE = 'PERMISSION_HAYNESCHECKLIST_UPDATE'

export const PERMISSION_HAYNESPROIFRAME_READ = 'PERMISSION_HAYNESPROIFRAME_READ'

export const PERMISSION_THIRDPARTYLICENSE_READ = 'PERMISSION_THIRDPARTYLICENSE_READ'

export const PERMISSION_MYKAR_READ = 'PERMISSION_MYKAR_READ'

export const PERMISSION_PAYMENT_PROVIDERS_READ = 'PERMISSION_PAYMENT_PROVIDERS_READ'

export const PERMISSION_SURVEY_PROVIDERS_READ = 'PERMISSION_SURVEY_PROVIDERS_READ'

export const PEMRISSION_ROAD_ASSISTANCE = 'PEMRISSION_ROAD_ASSISTANCE'
export const PERMISSION_TIME_CORRECTION = 'PERMISSION_TIME_CORRECTION'
// export const PERMISSION_EXTERNAL_WEBSITES = 'PERMISSION_EXTERNAL_WEBSITES'
export const PERMISSION_TYRE_STORAGE = 'PERMISSION_TYRE_STORAGE'
export const PERMISSION_CONCEPT_APP = 'PERMISSION_CONCEPT_APP'
export const PERMISSION_TYRE_WARRANTY = 'PERMISSION_TYRE_WARRANTY'

// TODO: Use a composite of all history items at some point
export const PERMISSION_HISTORY = 'PEMRISSION_HISTORY'

export const PERMISSION_HISTORYRECORD_CREATE = 'PERMISSION_HISTORYRECORD_CREATE'
export const PERMISSION_HISTORYRECORD_READ = 'PERMISSION_HISTORYRECORD_READ'
export const PERMISSION_HISTORYRECORD_UPDATE = 'PERMISSION_HISTORYRECORD_UPDATE'
export const PERMISSION_HISTORYRECORD_DELETE = 'PERMISSION_HISTORYRECORD_DELETE'

export const PERMISSION_HISTORYORDER_CREATE = 'PERMISSION_HISTORYORDER_CREATE'
export const PERMISSION_HISTORYORDER_READ = 'PERMISSION_HISTORYORDER_READ'
export const PERMISSION_HISTORYORDER_UPDATE = 'PERMISSION_HISTORYORDER_UPDATE'
export const PERMISSION_HISTORYORDER_DELETE = 'PERMISSION_HISTORYORDER_DELETE'

export const PERMISSION_OKRHISTORY_READ = 'PERMISSION_OKRHISTORY_READ'
export const PERMISSION_OKRHISTORY_UPDATE = 'PERMISSION_OKRHISTORY_UPDATE'

export const PERMISSION_INVOICE_CREATE = 'PERMISSION_INVOICE_CREATE'
export const PERMISSION_INVOICE_READ = 'PERMISSION_INVOICE_READ'
export const PERMISSION_INVOICE_UPDATE = 'PERMISSION_INVOICE_UPDATE'
export const PERMISSION_INVOICE_DELETE = 'PERMISSION_INVOICE_DELETE'

export const PERMISSION_INVOICEACCOUNT_CREATE = 'PERMISSION_INVOICEACCOUNT_CREATE'
export const PERMISSION_INVOICEACCOUNT_READ = 'PERMISSION_INVOICEACCOUNT_READ'
export const PERMISSION_INVOICEACCOUNT_UPDATE = 'PERMISSION_INVOICEACCOUNT_UPDATE'
export const PERMISSION_INVOICEACCOUNT_DELETE = 'PERMISSION_INVOICEACCOUNT_DELETE'

export const PERMISSION_INVOICECLOSINGSTATEMENT_CREATE = 'PERMISSION_INVOICECLOSINGSTATEMENT_CREATE'
export const PERMISSION_INVOICECLOSINGSTATEMENT_READ = 'PERMISSION_INVOICECLOSINGSTATEMENT_READ'
export const PERMISSION_INVOICECLOSINGSTATEMENT_UPDATE = 'PERMISSION_INVOICECLOSINGSTATEMENT_UPDATE'
export const PERMISSION_INVOICECLOSINGSTATEMENT_DELETE = 'PERMISSION_INVOICECLOSINGSTATEMENT_DELETE'

export const PERMISSION_INVOICESEQUENCE_CREATE = 'PERMISSION_INVOICESEQUENCE_CREATE'
export const PERMISSION_INVOICESEQUENCE_READ = 'PERMISSION_INVOICESEQUENCE_READ'
export const PERMISSION_INVOICESEQUENCE_UPDATE = 'PERMISSION_INVOICESEQUENCE_UPDATE'
export const PERMISSION_INVOICESEQUENCE_DELETE = 'PERMISSION_INVOICESEQUENCE_DELETE'

export const PERMISSION_LABOURRATE_CREATE = 'PERMISSION_LABOURRATE_CREATE'
export const PERMISSION_LABOURRATE_READ = 'PERMISSION_LABOURRATE_READ'
export const PERMISSION_LABOURRATE_UPDATE = 'PERMISSION_LABOURRATE_UPDATE'
export const PERMISSION_LABOURRATE_DELETE = 'PERMISSION_LABOURRATE_DELETE'

export const PERMISSION_WORKSTATION_READ = 'PERMISSION_WORKSTATION_READ'

export const PERMISSION_LEASECOMPANY = 'PERMISSION_LEASECOMPANY'
export const PERMISSION_LEASECOMPANY_DASHBOARD_WIDGET = 'PERMISSION_LEASECOMPANY_DASHBOARD_WIDGET'

export const PERMISSION_LEDGER_CREATE = 'PERMISSION_LEDGER_CREATE'
export const PERMISSION_LEDGER_READ = 'PERMISSION_LEDGER_READ'
export const PERMISSION_LEDGER_UPDATE = 'PERMISSION_LEDGER_UPDATE'
export const PERMISSION_LEDGER_DELETE = 'PERMISSION_LEDGER_DELETE'

export const PERMISSION_ORDER_PRINT = 'PERMISSION_ORDER_PRINT'
export const PERMISSION_ORDER_RECEIVE = 'PERMISSION_ORDER_RECEIVE'

export const PERMISSION_ORDERACCOUNT_CREATE = 'PERMISSION_ORDERACCOUNT_CREATE'
export const PERMISSION_ORDERACCOUNT_READ = 'PERMISSION_ORDERACCOUNT_READ'
export const PERMISSION_ORDERACCOUNT_UPDATE = 'PERMISSION_ORDERACCOUNT_UPDATE'
export const PERMISSION_ORDERACCOUNT_DELETE = 'PERMISSION_ORDERACCOUNT_DELETE'
export const PERMISSION_ORDERACCOUNT_HIDE = 'PERMISSION_ORDERACCOUNT_HIDE'

export const PERMISSION_ORDERS_CREATE = 'PERMISSION_ORDERS_CREATE'
export const PERMISSION_ORDERS_READ = 'PERMISSION_ORDERS_READ'
export const PERMISSION_ORDERS_UPDATE = 'PERMISSION_ORDERS_UPDATE'
export const PERMISSION_ORDERS_DELETE = 'PERMISSION_ORDERS_DELETE'

export const PERMISSION_PART_CREATE = 'PERMISSION_PART_CREATE'
export const PERMISSION_PART_READ = 'PERMISSION_PART_READ'
export const PERMISSION_PART_UPDATE = 'PERMISSION_PART_UPDATE'
export const PERMISSION_PART_DELETE = 'PERMISSION_PART_DELETE'

export const PERMISSION_ORDER_SUGGESTION_READ = 'PERMISSION_ORDER_SUGGESTION_READ'
export const PERMISSION_RECEIVE_STOCK_READ = 'PERMISSION_RECEIVE_STOCK_READ'

export const PERMISSION_STOCK_SETTINGS = 'PERMISSION_STOCK_SETTINGS'
export const PERMISSION_COUNTER_SETTINGS = 'PERMISSION_COUNTER_SETTINGS'

export const PERMISSION_PARTGROUP_CREATE = 'PERMISSION_PARTGROUP_CREATE'
export const PERMISSION_PARTGROUP_READ = 'PERMISSION_PARTGROUP_READ'
export const PERMISSION_PARTGROUP_UPDATE = 'PERMISSION_PARTGROUP_UPDATE'
export const PERMISSION_PARTGROUP_DELETE = 'PERMISSION_PARTGROUP_DELETE'

export const PERMISSION_PARTSHOP_CREATE = 'PERMISSION_PARTSHOP_CREATE'
export const PERMISSION_PARTSHOP_READ = 'PERMISSION_PARTSHOP_READ'
export const PERMISSION_PARTSHOP_UPDATE = 'PERMISSION_PARTSHOP_UPDATE'
export const PERMISSION_PARTSHOP_DELETE = 'PERMISSION_PARTSHOP_DELETE'

export const PERMISSION_PRICEMARKUP_READ = 'PERMISSION_PRICEMARKUP_READ'
export const PERMISSION_PRICEMARKUP_UPDATE = 'PERMISSION_PRICEMARKUP_UPDATE'

export const PERMISSION_QUOTATIONCLOSINGSTATEMENT_CREATE = 'PERMISSION_QUOTATIONCLOSINGSTATEMENT_CREATE'
export const PERMISSION_QUOTATIONCLOSINGSTATEMENT_READ = 'PERMISSION_QUOTATIONCLOSINGSTATEMENT_READ'
export const PERMISSION_QUOTATIONCLOSINGSTATEMENT_UPDATE = 'PERMISSION_QUOTATIONCLOSINGSTATEMENT_UPDATE'
export const PERMISSION_QUOTATIONCLOSINGSTATEMENT_DELETE = 'PERMISSION_QUOTATIONCLOSINGSTATEMENT_DELETE'

export const PERMISSION_RDWPROVIDERACCOUNT_CREATE = 'PERMISSION_RDWPROVIDERACCOUNT_CREATE'
export const PERMISSION_RDWPROVIDERACCOUNT_READ = 'PERMISSION_RDWPROVIDERACCOUNT_READ'
export const PERMISSION_RDWPROVIDERACCOUNT_UPDATE = 'PERMISSION_RDWPROVIDERACCOUNT_UPDATE'
export const PERMISSION_RDWPROVIDERACCOUNT_DELETE = 'PERMISSION_RDWPROVIDERACCOUNT_DELETE'

export const PERMISSION_CLOCKREGISTRATION_CREATE = 'PERMISSION_CLOCKREGISTRATION_CREATE'
export const PERMISSION_CLOCKREGISTRATION_READ = 'PERMISSION_CLOCKREGISTRATION_READ'
export const PERMISSION_CLOCKREGISTRATION_UPDATE = 'PERMISSION_CLOCKREGISTRATION_UPDATE'
export const PERMISSION_CLOCKREGISTRATION_DELETE = 'PERMISSION_CLOCKREGISTRATION_DELETE'

export const PERMISSION_IMPORT_DATA = 'PERMISSION_IMPORT_DATA'

export const PERMISSION_MOT_RDW = 'PERMISSION_MOT_RDW'

export const PERMISSION_RELEASENOTE_CREATE = 'PERMISSION_RELEASENOTE_CREATE'
export const PERMISSION_RELEASENOTE_READ = 'PERMISSION_RELEASENOTE_READ'
export const PERMISSION_RELEASENOTE_UPDATE = 'PERMISSION_RELEASENOTE_UPDATE'
export const PERMISSION_RELEASENOTE_DELETE = 'PERMISSION_RELEASENOTE_DELETE'

export const PERMISSION_RENTALVEHICLES_READ = 'PERMISSION_RENTALVEHICLES_READ'
export const PERMISSION_RENTALVEHICLES_UPDATE = 'PERMISSION_RENTALVEHICLES_UPDATE'

export const PERMISSION_REPLACEMENTVEHICLES_SETTINGS_READ = 'PERMISSION_REPLACEMENTVEHICLES_SETTINGS_READ'
export const PERMISSION_REPLACEMENTVEHICLES_SETTINGS_UPDATE = 'PERMISSION_REPLACEMENTVEHICLES_SETTINGS_UPDATE'

export const PERMISSION_SCHEDULER_SETTINGS = 'PERMISSION_SCHEDULER_SETTINGS'

export const PERMISSION_REVENUEGROUP_CREATE = 'PERMISSION_REVENUEGROUP_CREATE'
export const PERMISSION_REVENUEGROUP_READ = 'PERMISSION_REVENUEGROUP_READ'
export const PERMISSION_REVENUEGROUP_UPDATE = 'PERMISSION_REVENUEGROUP_UPDATE'
export const PERMISSION_REVENUEGROUP_DELETE = 'PERMISSION_REVENUEGROUP_DELETE'

export const PERMISSION_DEPARTMENTS_CREATE = 'PERMISSION_DEPARTMENTS_CREATE'
export const PERMISSION_DEPARTMENTS_READ = 'PERMISSION_DEPARTMENTS_READ'
export const PERMISSION_DEPARTMENTS_UPDATE = 'PERMISSION_DEPARTMENTS_UPDATE'
export const PERMISSION_DEPARTMENTS_DELETE = 'PERMISSION_DEPARTMENTS_DELETE'

export const PERMISSION_EXPENSE_OF_CREATE = 'PERMISSION_EXPENSE_OF_CREATE'
export const PERMISSION_EXPENSE_OF_READ = 'PERMISSION_EXPENSE_OF_READ'
export const PERMISSION_EXPENSE_OF_UPDATE = 'PERMISSION_EXPENSE_OF_UPDATE'
export const PERMISSION_EXPENSE_OF_DELETE = 'PERMISSION_EXPENSE_OF_DELETE'

export const PERMISSION_PAYMENTMETHOD_CREATE = 'PERMISSION_PAYMENTMETHOD_CREATE'
export const PERMISSION_PAYMENTMETHOD_READ = 'PERMISSION_PAYMENTMETHOD_READ'
export const PERMISSION_PAYMENTMETHOD_UPDATE = 'PERMISSION_PAYMENTMETHOD_UPDATE'
export const PERMISSION_PAYMENTMETHOD_DELETE = 'PERMISSION_PAYMENTMETHOD_DELETE'

export const PERMISSION_AT_EXPENSE_OF_READ = 'PERMISSION_DEPARTMENTS_READ'

// export const PERMISSION_ROBACCOUNT_CREATE = 'PERMISSION_ROBACCOUNT_CREATE'
// export const PERMISSION_ROBACCOUNT_READ = 'PERMISSION_ROBACCOUNT_READ'
// export const PERMISSION_ROBACCOUNT_UPDATE = 'PERMISSION_ROBACCOUNT_UPDATE'
// export const PERMISSION_ROBACCOUNT_DELETE = 'PERMISSION_ROBACCOUNT_DELETE'

export const PERMISSION_SHOP_CREATE = 'PERMISSION_SHOP_CREATE'
export const PERMISSION_SHOP_READ = 'PERMISSION_SHOP_READ'
export const PERMISSION_SHOP_UPDATE = 'PERMISSION_SHOP_UPDATE'
export const PERMISSION_SHOP_DELETE = 'PERMISSION_SHOP_DELETE'

export const PERMISSION_SMS_CREATE = 'PERMISSION_SMS_CREATE'
export const PERMISSION_SMS_READ = 'PERMISSION_SMS_READ'
export const PERMISSION_SMS_UPDATE = 'PERMISSION_SMS_UPDATE'
export const PERMISSION_SMS_DELETE = 'PERMISSION_SMS_DELETE'

export const PERMISSION_SMSHISTORY_CREATE = 'PERMISSION_SMSHISTORY_CREATE'
export const PERMISSION_SMSHISTORY_READ = 'PERMISSION_SMSHISTORY_READ'
export const PERMISSION_SMSHISTORY_UPDATE = 'PERMISSION_SMSHISTORY_UPDATE'
export const PERMISSION_SMSHISTORY_DELETE = 'PERMISSION_SMSHISTORY_DELETE'

export const PERMISSION_STATS_READ = 'PERMISSION_STATS_READ'
export const PERMISSION_STATS_TIMESHEET_READ = 'PERMISSION_STATS_TIMESHEET_READ'
export const PERMISSION_STATS_CLOCKED_READ = 'PERMISSION_STATS_TIMESHEET_READ'

export const PERMISSION_REPORTING_READ = 'PERMISSION_REPORTING_READ'

export const PERMISSION_SUNDRIES_READ = 'PERMISSION_SUNDRIES_READ'
export const PERMISSION_SUNDRIES_UPDATE = 'PERMISSION_SUNDRIES_UPDATE'

export const PERMISSION_SWITCH_DEFAULT_ORDER_ACCOUNT = 'PERMISSION_SWITCH_DEFAULT_ORDER_ACCOUNT'

export const PERMISSION_SYSTEMMESSAGE_CREATE = 'PERMISSION_SYSTEMMESSAGE_CREATE'
export const PERMISSION_SYSTEMMESSAGE_READ = 'PERMISSION_SYSTEMMESSAGE_READ'
export const PERMISSION_SYSTEMMESSAGE_UPDATE = 'PERMISSION_SYSTEMMESSAGE_UPDATE'
export const PERMISSION_SYSTEMMESSAGE_DELETE = 'PERMISSION_SYSTEMMESSAGE_DELETE'

export const PERMISSION_THEME_CREATE = 'PERMISSION_THEME_CREATE'
export const PERMISSION_THEME_READ = 'PERMISSION_THEME_READ'
export const PERMISSION_THEME_UPDATE = 'PERMISSION_THEME_UPDATE'
export const PERMISSION_THEME_DELETE = 'PERMISSION_THEME_DELETE'

export const PERMISSION_TYRE_CHANGE_READ = 'PERMISSION_TYRE_CHANGE_READ'
export const PERMISSION_TYRE_CHANGE_UPDATE = 'PERMISSION_TYRE_CHANGE_UPDATE'

export const PERMISSION_VEHICLE_CREATE = 'PERMISSION_VEHICLE_CREATE'
export const PERMISSION_VEHICLE_READ = 'PERMISSION_VEHICLE_READ'
export const PERMISSION_VEHICLE_UPDATE = 'PERMISSION_VEHICLE_UPDATE'
export const PERMISSION_VEHICLE_DELETE = 'PERMISSION_VEHICLE_DELETE'

export const PERMISSION_COUNTER_CREATE = 'PERMISSION_COUNTER_CREATE'
export const PERMISSION_COUNTER_READ = 'PERMISSION_COUNTER_READ'
export const PERMISSION_COUNTER_UPDATE = 'PERMISSION_COUNTER_UPDATE'
export const PERMISSION_COUNTER_DELETE = 'PERMISSION_COUNTER_DELETE'

export const PERMISSION_VEHICLE_SEARCH_BY_COUNTRY = 'PERMISSION_VEHICLE_SEARCH_BY_COUNTRY'

export const PERMISSION_WHOLESALER_CREATE = 'PERMISSION_WHOLESALER_CREATE'
export const PERMISSION_WHOLESALER_READ = 'PERMISSION_WHOLESALER_READ'
export const PERMISSION_WHOLESALER_UPDATE = 'PERMISSION_WHOLESALER_UPDATE'
export const PERMISSION_WHOLESALER_DELETE = 'PERMISSION_WHOLESALER_DELETE'

export const PERMISSION_WORKHOURS_CREATE = 'PERMISSION_WORKHOURS_CREATE'
export const PERMISSION_WORKHOURS_READ = 'PERMISSION_WORKHOURS_READ'
export const PERMISSION_WORKHOURS_UPDATE = 'PERMISSION_WORKHOURS_UPDATE'
export const PERMISSION_WORKHOURS_DELETE = 'PERMISSION_WORKHOURS_DELETE'

export const PERMISSION_WORKORDER_CREATE = 'PERMISSION_WORKORDER_CREATE'
export const PERMISSION_WORKORDER_READ = 'PERMISSION_WORKORDER_READ'
export const PERMISSION_WORKORDER_UPDATE = 'PERMISSION_WORKORDER_UPDATE'
export const PERMISSION_WORKORDER_DELETE = 'PERMISSION_WORKORDER_DELETE'

export const PERMISSION_WORKORDER_REMARK = 'PERMISSION_WORKORDER_REMARK'
export const PERMISSION_WORKORDER_IMAGES = 'PERMISSION_WORKORDER_IMAGES'
export const PERMISSION_WORKORDER_PRINT = 'PERMISSION_WORKORDER_PRINT'
export const PERMISSION_WORKORDER_INVOICE_CREATE = 'PERMISSION_WORKORDER_INVOICE_CREATE'
export const PERMISSION_WORKORDER_INVOICE_READ = 'PERMISSION_WORKORDER_INVOICE_READ'

export const PERMISSION_WORKORDERLINE_LABOURRATE_CREATE = 'PERMISSION_WORKORDERLINE_LABOURRATE_CREATE'
export const PERMISSION_WORKORDERLINE_LABOURRATE_UPDATE = 'PERMISSION_WORKORDERLINE_LABOURRATE_UPDATE'
export const PERMISSION_WORKORDERLINE_LABOURRATE_DELETE = 'PERMISSION_WORKORDERLINE_LABOURRATE_DELETE'
export const PERMISSION_WORKORDERLINE_ACTIVITY_CREATE = 'PERMISSION_WORKORDERLINE_ACTIVITY_CREATE'
export const PERMISSION_WORKORDERLINE_ACTIVITY_UPDATE = 'PERMISSION_WORKORDERLINE_ACTIVITY_UPDATE'
export const PERMISSION_WORKORDERLINE_ACTIVITY_DELETE = 'PERMISSION_WORKORDERLINE_ACTIVITY_DELETE'
export const PERMISSION_WORKORDERLINE_PART_CREATE = 'PERMISSION_WORKORDERLINE_PART_CREATE'
export const PERMISSION_WORKORDERLINE_PART_UPDATE = 'PERMISSION_WORKORDERLINE_PART_UPDATE'
export const PERMISSION_WORKORDERLINE_PART_DELETE = 'PERMISSION_WORKORDERLINE_PART_DELETE'
export const PERMISSION_WORKORDERLINE_SUNDRIES_CREATE = 'PERMISSION_WORKORDERLINE_SUNDRIES_CREATE'
export const PERMISSION_WORKORDERLINE_SUNDRIES_UPDATE = 'PERMISSION_WORKORDERLINE_SUNDRIES_UPDATE'
export const PERMISSION_WORKORDERLINE_SUNDRIES_DELETE = 'PERMISSION_WORKORDERLINE_SUNDRIES_DELETE'
export const PERMISSION_WORKORDERLINE_UNIVERSALPART_CREATE = 'PERMISSION_WORKORDERLINE_UNIVERSALPART_CREATE'
export const PERMISSION_WORKORDERLINE_UNIVERSALPART_UPDATE = 'PERMISSION_WORKORDERLINE_UNIVERSALPART_UPDATE'
export const PERMISSION_WORKORDERLINE_UNIVERSALPART_DELETE = 'PERMISSION_WORKORDERLINE_UNIVERSALPART_DELETE'
export const PERMISSION_WORKORDERLINE_TOOLSPECIAL_CREATE = 'PERMISSION_WORKORDERLINE_TOOLSPECIAL_CREATE'
export const PERMISSION_WORKORDERLINE_TOOLSPECIAL_UPDATE = 'PERMISSION_WORKORDERLINE_TOOLSPECIAL_UPDATE'
export const PERMISSION_WORKORDERLINE_TOOLSPECIAL_DELETE = 'PERMISSION_WORKORDERLINE_TOOLSPECIAL_DELETE'
export const PERMISSION_WORKORDERLINE_CHAPTER_CREATE = 'PERMISSION_WORKORDERLINE_CHAPTER_CREATE'
export const PERMISSION_WORKORDERLINE_DISCOUNT_CREATE = 'PERMISSION_WORKORDERLINE_DISCOUNT_CREATE'

export const PERMISSION_WORKORDERLINE_STATUS_TOGGLE = 'PERMISSION_WORKORDERLINE_STATUS_TOGGLE'

export const PERMISSION_WORKORDERNUMBER_READ = 'PERMISSION_WORKORDERNUMBER_READ'
export const PERMISSION_WORKORDERNUMBER_UPDATE = 'PERMISSION_WORKORDERNUMBER_UPDATE'

export const PERMISSION_WORKORDER_QUOTATIONS_READ = 'PERMISSION_WORKORDER_QUOTATIONS_READ'
export const PERMISSION_WORKORDER_QUOTATIONS_UPDATE = 'PERMISSION_WORKORDER_QUOTATIONS_UPDATE'

export const PERMISSION_WARRANTY_CLAIMS_READ = 'PERMISSION_WARRANTY_CLAIMS_READ'
export const PERMISSION_WARRANTY_CLAIMS_UPDATE = 'PERMISSION_WARRANTY_CLAIMS_UPDATE'

export const PERMISSION_ORDER_QUOTATIONS_READ = 'PERMISSION_ORDER_QUOTATIONS_READ'
export const PERMISSION_ORDER_QUOTATIONS_UPDATE = 'PERMISSION_ORDER_QUOTATIONS_UPDATE'

export const PERMISSION_WORKORDERINVOICEEXPORT_CREATE = 'PERMISSION_WORKORDERINVOICEEXPORT_CREATE'
export const PERMISSION_WORKORDERINVOICEEXPORT_READ = 'PERMISSION_WORKORDERINVOICEEXPORT_READ'
export const PERMISSION_WORKORDERINVOICEEXPORT_UPDATE = 'PERMISSION_WORKORDERINVOICEEXPORT_UPDATE'
export const PERMISSION_WORKORDERINVOICEEXPORT_DELETE = 'PERMISSION_WORKORDERINVOICEEXPORT_DELETE'

export const PERMISSION_VAT_RETURN_READ = 'PERMISSION_VAT_RETURN_READ'

export const PERMISSION_VEHICLESALES_CREATE = 'PERMISSION_VEHICLESALES_CREATE'
export const PERMISSION_VEHICLESALES_READ = 'PERMISSION_VEHICLESALES_READ'
export const PERMISSION_VEHICLESALES_UPDATE = 'PERMISSION_VEHICLESALES_UPDATE'
export const PERMISSION_VEHICLESALES_DELETE = 'PERMISSION_VEHICLESALES_DELETE'

export const PERMISSION_VEHICLESALES_MODULE = 'PERMISSION_VEHICLESALES_MODULE'

export const PERMISSION_EXTERNAL_PARTS_SETTINGS_READ = 'PERMISSION_EXTERNAL_PARTS_READ'
export const PERMISSION_EXTERNAL_PARTS_SETTINGS_UPDATE = 'PERMISSION_EXTERNAL_PARTS_UPDATE'

export const PERMISSION_APPOINTMENT_PROPOSAL_READ = 'PERMISSION_APPOINTMENT_PROPOSAL_READ'
export const PERMISSION_APPOINTMENT_PROPOSAL_CONVERT = 'PERMISSION_APPOINTMENT_PROPOSAL_CONVERT'
export const PERMISSION_APPOINTMENT_PROPOSAL_UPDATE = 'PERMISSION_APPOINTMENT_PROPOSAL_UPDATE'

export const PERMISSION_INTAKE_PROPOSAL_READ = 'PERMISSION_INTAKE_PROPOSAL_READ'
export const PERMISSION_INTAKE_PROPOSAL_CONVERT = 'PERMISSION_INTAKE_PROPOSAL_CONVERT'
export const PERMISSION_INTAKE_PROPOSAL_UPDATE = 'PERMISSION_INTAKE_PROPOSAL_UPDATE'

export const PERMISSION_CRM_CREATE = 'PERMISSION_CRM_CREATE'
export const PERMISSION_CRM_READ = 'PERMISSION_CRM_READ'
export const PERMISSION_CRM_UPDATE = 'PERMISSION_CRM_UPDATE'
export const PERMISSION_CRM_DELETE = 'PERMISSION_CRM_DELETE'

export const PERMISSION_CRM_ACCOUNT_COMMUNICATIONCHANNEL_UPDATE = 'PERMISSION_CRM_ACCOUNT_COMMUNICATIONCHANNEL_UPDATE'

export const PERMISSION_RMA_CREATE = 'PERMISSION_RMA_CREATE'
export const PERMISSION_RMA_READ = 'PERMISSION_RMA_READ'

export const PERMISSION_LINKS_WIDGET = 'PERMISSION_LINKS_WIDGET'

export const PERMISSION_APPOINTMENT_CAN_ASSIGN_MECHANIC = 'PERMISSION_APPOINTMENT_CAN_ASSIGN_MECHANIC'
export const PERMISSION_APPOINTMENT_CAN_ASSIGN_WORKSTATION = 'PERMISSION_APPOINTMENT_CAN_ASSIGN_WORKSTATION'
export const PERMISSION_APPOINTMENT_CAN_VIEW_MONTH = 'PERMISSION_APPOINTMENT_CAN_VIEW_MONTH'
export const PERMISSION_APPOINTMENT_CAN_PLAN_WORKORDER = 'PERMISSION_APPOINTMENT_CAN_PLAN_WORKORDER'
export const PERMISSION_APPOINTMENT_CAN_PLAN_PROPOSAL = 'PERMISSION_APPOINTMENT_CAN_PLAN_PROPOSAL'
export const PERMISSION_APPOINTMENT_CAN_DRAG_ITEM = 'PERMISSION_APPOINTMENT_CAN_DRAG_ITEM'

export const PERMISSION_RETURNS_SHOP_SETTING_READ = 'PERMISSION_RETURNS_SHOP_SETTING_READ'

export const PERMISSION_EXTERNALINVOICE_READ = 'PERMISSION_EXTERNALINVOICE_READ'

export const PERMISSION_REQUIRES_FLEET_LEASE_SETUP_TO_BE_DONE = 'PERMISSION_REQUIRES_FLEET_LEASE_SETUP_TO_BE_DONE'

export const PERMISSION_LEASE_WORKORDER_SWITCH = 'PERMISSION_LEASE_WORKORDER_SWITCH'

export const PERMISSION_INTERNAL_INVOICING = 'PERMISSION_INTERNAL_INVOICING'

export const PERMISSION_GENART_ADD_FROM_OFFLINE_PURCHASE = 'PERMISSION_GENART_ADD_FROM_OFFLINE_PURCHASE'

export const PERMISSION_GENART_ADD_FROM_STOCK = 'PERMISSION_GENART_ADD_FROM_STOCK'

export const PERMISSION_BACK_TO_WORK_ORDER_ARROW_BUTTON = 'PERMISSION_BACK_TO_WORK_ORDER_ARROW_BUTTON'

export const PERMISSION_ACTION_CREATE = 'PERMISSION_ACTION_CREATE'
export const PERMISSION_ACTION_READ = 'PERMISSION_ACTION_READ'
export const PERMISSION_ACTION_UPDATE = 'PERMISSION_ACTION_UPDATE'
export const PERMISSION_ACTION_DELETE = 'PERMISSION_ACTION_DELETE'
export const PERMISSION_WOM_PLUS = 'PERMISSION_WOM_PLUS'

export const PERMISSION_EXTERNAL_WEBSITES = 'PERMISSION_EXERNAL_WEBSITES'

export const PERMISSION_SUPPLIER_ORDERS_READ = 'PERMISSION_SUPPLIER_ORDERS_READ'

export const PERMISSION_BCC_EMAIL = 'PERMISSION_BCC_EMAIL'
